module.exports = __webpack_public_path__ + "static/media/united-nations.9b32ab26.svg";